export default __webpack_public_path__ + "static/img-dealean-capital-c7fa5e3bc3d5cb8c24e6695ee8bf0504.png";